import { LineChartKey } from '.';
export var createLineChartDriver = function (wrapper) {
    var base = wrapper.$("." + LineChartKey);
    return {
        getPlottedLineCount: function () { return base.$$('.recharts-area-area').count(); },
        getXAxisLabels: function () { return base.$$('.xAxis .recharts-cartesian-axis-tick-value').text(); },
        getXAxisTickLabels: function () { return base.$$('.xAxis .recharts-cartesian-axis-tick').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map